exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hidden_header {\n\tdisplay: none;\n}\n.missing-info-text {\n\tcolor: rgba(117, 102, 31, 0.74) !important;\n\tfont-style: italic;\n}\n", ""]);

// exports
